<template>
  <td
    v-if="
      doc.USER_IS_RULES_DOWNLOAD_FILE == 1 &&
        doc.FILE_INFO.UF_IS_DOWNLOAD_YES == 1
    "
  >
    <button class="tab-but-doc" @click="sUploader">
      Загрузить документ
    </button>
    <div
      class="modal fade in show"
      v-if="showUploader"
      tabindex="-1"
      role="dialog"
    >
      <div class="window-doc" v-show="!showECP" style="left: 35%">
        <h3 style="margin-bottom: 35px;">ЗАГРУЗКА ДОКУМЕНТА</h3>
        <form
          action="#"
          @submit.prevent="submit"
          class="load-doc"
          style="padding-right: 20px"
        >
          <p class="hidden">
            <label>Вид документа</label>
            <select
              @change="bindChange"
              v-model="typeIndex"
              class="i-style i-style-sel"
              :disabled="false"
            >
              <template v-for="(docL, docIndex) in docsType">
                <option
                  v-if="
                    docL.USER_IS_RULES_DOWNLOAD_FILE == 1 &&
                      docL.FILE_INFO != undefined &&
                      docL.FILE_INFO.UF_IS_DOWNLOAD_YES == 1
                  "
                  :selected="typeIndex == docIndex ? true : false"
                  :value="docIndex"
                  :key="docIndex"
                >
                  {{
                    docL.NAME_NEW_TYPE ? docL.NAME_NEW_TYPE : docL.NAME
                  }}
                </option
                >
              </template>
            </select>
          </p>
          <p
            style="text-align: left"
            v-html="doc.NAME_NEW_TYPE ? doc.NAME_NEW_TYPE : doc.NAME"
          ></p>
          <div class="file-upload" v-if="fileName">
            <div class="file-upload-label">Файл:</div>
            <button type="button">Выберите файл</button>
            <div v-text="fileName"></div>
            <input
              id="uploadFile"
              type="file"
              :accept="accept"
              name="file"
              ref="file"
              @change="changeFile"
            />
          </div>
          <div class="row"><span v-text="fileName2"></span></div>

          <div class="alert alert-info">
            Максимальный размер файла для загрузки - 100 Мб. <br />
            Для загрузки нескольких файлов их необходимо объединить в архив
          </div>

          <div v-if="errorText" class="alert alert-danger">
            {{ errorText }}
          </div>
          <div v-show="typeIndex >= 0 && doc.IS_ECP_REQ && !isEDSWorkAndGood">
            Файл требует обязательной подписи!
          </div>
          <div v-show="isEDSWorkAndGood" class="alert alert-success">
            Документ успешно подписан и готов к загрузке в систему
          </div>

          <div v-show="showLoaderIcon" style="padding-top: 10px; color:orange ">
            Идет подготовка к подписи файла
            <img src="/img/waiting.gif" style="width:20px;" />
          </div>

          <div
            v-for="err in errorArr"
            class="alert alert-danger"
            style="margin-top: 10px"
          >
            {{ err.TEXT }}
          </div>
          <div class="foot-butt center-block" style="text-align: center">
            <button type="button" class="b-o" @click="showUploader = false">
              Отмена
            </button>
            <button
              v-if="this.addDocForm.FILE && !uploadAvailable"
              type="button"
              @click="startECP()"
              class="b-l"
            >
              Подписать
            </button>
            <button
              type="submit"
              :class="!uploadBlockButton ? 'b-l' : ''"
              v-show="uploadAvailable"
              :disabled="!uploadAvailable || uploadBlockButton"
            >
              Загрузить
            </button>
          </div>
        </form>
      </div>
      <div class="window-doc" v-show="showECP">
        <h3>ПОДПИСЬ ДОКУМЕНТА</h3>
        <div v-if="!ecpPluginEnabled" style="color: red;text-align: center">
          Плагин не активен
        </div>
        <div v-else style="color: green;text-align: center; padding-bottom: 20px;">
          Плагин загружен.
        </div>
        <br />
        <form action="#" @submit.prevent="submit" class="load-doc">
          <div>
            <strong>Укажите сертификат подписи</strong>
          </div>
          <select
            v-model="ecpCert"
            class="i-style i-style-sel"
            style="width: 555px"
          >
            <option v-for="cert in ecpCerts" :value="cert"
            >{{ cert.text }}
            </option>
          </select>
          <br />
          <br />
          <div>
            <a :href="siteUrl + 'methods/doc/Инструкция_ЭЦП.pdf'"
            >Инструкция по установке ЭЦП</a
            >
            <br />КриптоПро ЭЦП Browser plug-in
            <a href="https://www.cryptopro.ru/products/cades/plugin/get_2_0"
            >скачать</a
            >
          </div>

          <div v-show="showLoaderIconFile" style="padding-top: 10px; color:orange ">
            Идет формирование ЭЦП файла
            <img src="/img/waiting.gif" style="width:20px;" />
          </div>

          <div class="foot-butt center-block" style="text-align: center">
            <button type="button" class="b-o" @click="showUploader = false">
              Отмена
            </button>
            <button
              type="button"
              :disabled="ecpCert === null"
              @click="Common_SignCadesBES_File()"
              class="b-l"
            >
              Подписать
            </button>
          </div>
        </form>
      </div>
    </div>
  </td>
  <td v-else></td>
</template>

<script>
/*global cadesplugin*/
import { ProjectsService } from "@/common/api.service";
import { mapGetters } from "vuex";
import "@/scripts/cadesplugin_api";
import { AUTH_URL } from "@/common/config";

export default {
  name: "UploadCellAddDZ",
  props: ["parent", "doc", "docs", "docsType", "documentConf", "project"],
  data() {
    return {
      fileForm: {
        TYPE_ID: 0,
        file: "",
        EXPERTISE_ID: 0
      },
      errorText: "",
      showUploader: false,
      typeIndex: -1,
      docName: "",
      file: "",
      fileName: "Файл не выбран",
      fileName2: "",
      accept: "",
      showECP: false,
      ecpPluginEnabled: false,
      ecpCerts: [],
      ecpValue: "",
      ecpCert: null,
      isLoadCert: false,
      ecpEnsurer: "",
      fileBase64: "",
      siteUrl: "",
      uploadBlockButton: false,
      errorArr: [],
      addDocForm: {
        FILE_NAME: "",
        FILE: ""
      },
      showLoaderIcon: false,
      showLoaderIconFile: false,
      hashFile: "",
      isBigFile: false,
      isEDSWorkAndGood:false
    };
  },
  mounted() {
    this.bindChange();
    this.siteUrl = AUTH_URL;
  },
  computed: {
    docNames() {
      if (this.typeIndex < 0) {
        return false;
      }
      /*if (!this.docs[this.typeIndex].IS_MULTIPLY) {
        return false;
      }
      if (
        !this.documentConf.FILE_DOCUMENTS_PATH[
          this.docs[this.typeIndex].TYPE_ID
        ]
      ) {
        return false;
      }*/
      let docNames = [];

      return docNames;
    },
    docExts() {
      let exts = [];
      if (this.docNames) {
        this.docNames.forEach(function(d) {
          if (d.ID === this.docName) {
            d.UF_FORMAT_REQ_FILE.split(";").forEach(function(v) {
              if (v !== "") {
                exts.push(v);
              }
            });
          }
        }, this);
      }
      return exts;
    },
    uploadAvailable() {
      if (this.fileName === "Файл не выбран") {
        return false;
      }
      if (this.typeIndex < 0) {
        return false;
      }
      if (this.docsType[this.typeIndex].IS_MULTIPLY && this.docName === "") {
        return false;
      }
      if (this.docsType[this.typeIndex].IS_ECP_REQ && !this.ecpValue) {
        return false;
      }

      return true;
    },
    ecpAvailable() {
      if (this.typeIndex < 0) {
        return false;
      }
      if (this.docsType[this.typeIndex].IS_ECP) {
        return true;
      }

      return false;
    },
    ...mapGetters(["currentUser"])
  },
  methods: {
    aDocs() {
      let rDocs = {};
      let r = false;

      if (!this.docs) {
        return r;
      }

      Object.keys(this.docs).map(function(i) {
        if (
          (this.currentUser.TYPE_USER === "declarer" &&
            this.docs[i].IS_LOAD_FILE_USER) ||
          (this.currentUser.TYPE_USER === "manager" &&
            this.docs[i].IS_LOAD_FILE_MANAGER)
        ) {
          let skip = false;
          if (
            this.currentUser.TYPE_USER === "manager" &&
            this.docs[i].IS_LOAD_FILE_MANAGER
          ) {
            skip = true;

            this.docs[i].GROUP_LOAD_MANAGER_LIST.forEach(function(v) {
              if (this.currentUser.ACTIVE_ROLE_CODE === v.ACTIVE_CODE) {
                skip = false;
              }
            }, this);
          }
          if (this.docs[i].FILE_INFO) {
            if (this.docs[i].FILE_INFO.UF_IS_DOWNLOAD_YES == 0) {
              skip = true;
            }
          } else if (this.docs[i].FILE_INFO == undefined) {
            skip = true;
          }

          /*if (this.documentConf.FILE_DOCUMENTS_PATH[this.docs[i].TYPE_ID]) {
            let k = this.documentConf.FILE_DOCUMENTS_PATH[this.docs[i].TYPE_ID];
            if (this.parent && this.parent.RECORD_MODEL_ID > 0) {
              k.forEach(function(el) {
                if (el.RECORD_MODEL_ID === this.parent.RECORD_MODEL_ID) {
                  if (el.UF_IS_AKCEPT > 0 && el.UF_IS_AKCEPT != 2) {
                    skip = true;
                  }
                }
              }, this);
            } else {
              if (
                k[k.length - 1].UF_IS_AKCEPT > 0 &&
                k[k.length - 1].UF_IS_AKCEPT != 2
              ) {
                skip = true;
              }
            }
          }*/
          if (!skip) {
            rDocs[i] = this.docs[i];
          }
          r = true;
        }
      }, this);
      if (r && Object.keys(rDocs).length) {
        return rDocs;
      }
      return false;
    },
    sUploader() {
      this.showUploader = !this.showUploader;
      this.typeIndex = -1;
      this.docName = "";
      this.file = "";
      this.fileName = "Файл не выбран";
      this.fileName2 = "";
      this.showECP = false;
      this.ecpPluginEnabled = false;
      this.ecpCerts = [];
      this.ecpValue = "";
      this.ecpEnsurer = "";
      this.fileBase64 = "";
      this.errorArr = [];
      this.errorText = "";
      this.isLoadCert = false;
      this.addDocForm.FILE = "";
      this.addDocForm.FILE_NAME = "";
      this.uploadBlockButton = false;

      this.docsType.forEach(function(d, index) {
        if (
          d.FILE_INFO != undefined &&
          d.FILE_INFO.ID === this.doc.FILE_INFO.ID
        ) {
          this.typeIndex = index;
        }
      }, this);

      this.accept = "";
      if (this.doc.EXT !== "") {
        this.accept = "." + this.doc.EXT.replaceAll(",", ",.");
      }
    },
    startECP() {
      //запуск метода получения хеш
      /* this.showLoaderIcon = true;
       this.hashFile = "";
       this.fileBase64 = "";
       let formDataHash = new FormData();
       formDataHash.append("FILE", this.addDocForm.FILE);
       ProjectsService.getHashFile(formDataHash).then(response => {
         this.hashFile = response.data.HASH;
         this.fileBase64 = this.hashFile;
         this.showLoaderIcon = false;

         this.showECP = true;
         this.Common_CheckForPlugIn();
       }, this);*/

      this.showECP = true;
      this.Common_CheckForPlugIn();
    },
    Common_CheckForPlugIn() {
      cadesplugin.set_log_level(cadesplugin.LOG_LEVEL_DEBUG);
      let canAsync = !!cadesplugin.CreateObjectAsync;
      if (canAsync) {
        return this.CheckForPlugIn_Async();
      } else {
        //return CheckForPlugIn_NPAPI();
      }
    },
    CheckForPlugIn_Async() {
      this.ecpPluginEnabled = true;
      let _this = this;
      cadesplugin.async_spawn(function* () {
        //let oAbout = yield cadesplugin.CreateObjectAsync("CAdESCOM.About");
        yield _this.FillCertList_Async();
      });
    },
    updateDocInfo() {
      ProjectsService.getDocumentDZProjects(this.$route.params.id).then(
        ({ data }) => {
          this.documentConf.FILE_LOAD_INFO = data.FILE_LOAD_INFO;
          this.documentConf.FILE_ACCEPT_INFO = data.FILE_ACCEPT_INFO;
          this.documentConf.FILE_DOCUMENTS_PATH = data.FILE_DOCUMENTS_PATH;
          this.documentConf.LIST_TYPE = data.LIST_TYPE;
          this.documentConf.SHOW_SAVE_SESSION = data.SHOW_SAVE_SESSION;
          this.documentConf.IS_BLOCK_BUTTON_SET_VERSION =
            data.IS_BLOCK_BUTTON_SET_VERSION;
          if (this.documentConf.SHOW_SAVE_SESSION == 1) {
            this.showAlertSave = true;
          }
        },
        this
      );
    },
    FillCertList_Async() {
      let _this = this;
      cadesplugin.async_spawn(function* () {
        let oStore;
        try {
          oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
          if (!oStore) {
            alert("Ошибка чтения сертификатов ЭЦП");
            return;
          }

          yield oStore.Open();
        } catch (ex) {
          alert("Ошибка чтения сертификатов ЭЦП");
        }

        let CertificatesObj = yield oStore.Certificates;

        let certCnt = yield CertificatesObj.Count;
        if (certCnt == 0) {
          throw "Сертификаты не найдены";
        }

        try {
          yield oStore.Open(cadesplugin.CADESCOM_CONTAINER_STORE);
          let certs = yield oStore.Certificates;
          let certCnt = yield certs.Count;
          for (let i = 1; i <= certCnt; i++) {
            let cert = yield certs.Item(i);

            let oOpt = {
              text: "",
              value: ""
            };
            oOpt.text = yield cert.SubjectName;
            oOpt.value = yield cert.Thumbprint;
            console.log("ceeert", oOpt);
            console.log(_this.isLoadCert);
            if (!_this.isLoadCert) {
              _this.ecpCerts.push(oOpt);
            }
          }
          yield oStore.Close();
          _this.isLoadCert = true;
        } catch (ex) {
          console.log(ex);
        }
      });
    },
    Common_SignCadesBES_File() {
      let canAsync = !!cadesplugin.CreateObjectAsync;
      if (canAsync) {
        if (this.isBigFile) {
          console.log("Подпись большого файла");
          return this.SignCadesBES_Async_File_By_Parts();
        } else {
          return this.SignCadesBES_Async_File();
        }
      } else {
        //return SignCadesBES_NPAPI_File(id);
      }
    },

    SignCadesBES_Async_File() {
      let _this = this;
      cadesplugin.async_spawn(function* () {
        try {
          //FillCertInfo_Async(certificate);
          let oSigner;
          let errormes = "";
          try {
            oSigner = yield cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner");
          } catch (err) {
            errormes = "Failed to create CAdESCOM.CPSigner: " + err.number;
            throw errormes;
          }
          let oSigningTimeAttr = yield cadesplugin.CreateObjectAsync(
            "CADESCOM.CPAttribute"
          );

          let CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0;
          yield oSigningTimeAttr.propset_Name(
            CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME
          );
          let oTimeNow = new Date();
          yield oSigningTimeAttr.propset_Value(oTimeNow);
          let attr = yield oSigner.AuthenticatedAttributes2;
          yield attr.Add(oSigningTimeAttr);

          let oDocumentNameAttr = yield cadesplugin.CreateObjectAsync(
            "CADESCOM.CPAttribute"
          );
          let CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME = 1;
          yield oDocumentNameAttr.propset_Name(
            CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME
          );
          yield oDocumentNameAttr.propset_Value("Document Name");
          yield attr.Add(oDocumentNameAttr);

          let oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
          try {
            oStore.Open(cadesplugin.CADESCOM_CONTAINER_STORE);
          } catch (e) {
            alert("Ошибка при открытии хранилища");
            console.log(e);
            return;
          }

          let CertificatesObj = yield oStore.Certificates;
          let CAPICOM_CERTIFICATE_FIND_SHA1_HASH = 0;
          let oCerts = yield CertificatesObj.Find(
            CAPICOM_CERTIFICATE_FIND_SHA1_HASH,
            _this.ecpCert.value
          );

          if (oCerts.Count == 0) {
            errormes = "Certs not found";
            throw errormes;
          }

          let oCert = yield oCerts.Item(1);
          let sName = yield oCert.SubjectName;

          if (oSigner) {
            yield oSigner.propset_Certificate(oCert);
            yield oSigner.propset_CheckCertificate(true);
          } else {
            errormes = "Failed to create CAdESCOM.CPSigner";
            throw errormes;
          }

          let oSignedData = yield cadesplugin.CreateObjectAsync(
            "CAdESCOM.CadesSignedData"
          );
          let CADES_BES = 1;
          let dataToSign = _this.fileBase64;
          if (dataToSign) {
            yield oSignedData.propset_ContentEncoding(1); //CADESCOM_BASE64_TO_BINARY
            yield oSignedData.propset_Content(dataToSign);
            yield oSigner.propset_Options(1); //CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN
            try {
              _this.ecpValue = yield oSignedData.SignCades(oSigner, CADES_BES, true);
              _this.showECP = false;
              let sn = sName.split(",");
              sn.forEach(function(v) {
                let r = v.replace("CN=", "");
                if (r.length !== v.length) {
                  _this.ecpEnsurer = r.trim();
                }
              });
            } catch (err) {
              throw err;
            }
            yield oStore.Close();

            var oSignedData2 = yield cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");
            try {
              yield oSignedData2.propset_ContentEncoding(cadesplugin.CADESCOM_BASE64_TO_BINARY);
              yield oSignedData2.propset_Content(dataToSign);
              yield oSignedData2.VerifyCades( _this.ecpValue, cadesplugin.CADESCOM_CADES_BES, true);
              _this.isEDSWorkAndGood = true;
              console.log("Signature verified");
            } catch (err) {
              alert("Failed to verify signature. Error: " + cadesplugin.getLastError(err));
              return;
            }

          }
          //alert(Signature)
        } catch (err) {
          console.log("sign err", err);
          alert(`У сертификата подписи: ${err.message}`);
        }
      });
    },
  //подпись файла по частям https://docs.cryptopro.ru/cades/plugin/plugin-samples/plugin-samples-fileapi_stream
    SignCadesBES_Async_File_By_Parts() {
      let _this = this;
      cadesplugin.async_spawn(function* (args) {
        let errormes = "";

        if (1 !== document.getElementById("uploadFile").files.length) {
          alert("Select the file.");
          return;
        }
        var oFile = document.getElementById("uploadFile").files[0];

        var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
        var chunkSize = 3 * 1024 * 1024; // 3MB
        var chunks = Math.ceil(oFile.size / chunkSize);
        var currentChunk = 0;

        var oHashedData = yield cadesplugin.CreateObjectAsync("CAdESCOM.HashedData");

        //!
        yield oHashedData.propset_Algorithm(cadesplugin.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256);

        yield oHashedData.propset_DataEncoding(cadesplugin.CADESCOM_BASE64_TO_BINARY);

        //открыть loader
        _this.showLoaderIconFile = true;

        var frOnload = function(e) {
          var header = ";base64,";
          var sFileData = e.target.result;
          var sBase64Data = sFileData.substr(sFileData.indexOf(header) + header.length);

          oHashedData.Hash(sBase64Data);

          currentChunk++;

          if (currentChunk < chunks) {
            loadNext();
          } else {
            cadesplugin.async_spawn(function* (args) {

              _this.showLoaderIconFile = false;

              var oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
              yield oStore.Open(
                cadesplugin.CAPICOM_CURRENT_USER_STORE,
                cadesplugin.CAPICOM_MY_STORE,
                cadesplugin.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED
              );

              var oStoreCerts = yield oStore.Certificates;
              let CAPICOM_CERTIFICATE_FIND_SHA1_HASH = 0;
              var oCertificates = yield oStoreCerts.Find(
                CAPICOM_CERTIFICATE_FIND_SHA1_HASH,
                _this.ecpCert.value
              );

              var certsCount = yield oCertificates.Count;
              if (certsCount === 0) {
                alert("Certificate not found: " + _this.ecpCert.value);
                return;
              }
              var oCertificate = yield oCertificates.Item(1);
              let sCertName = yield oCertificate.SubjectName;

              var oSigner = yield cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner");
              yield oSigner.propset_Certificate(oCertificate);
              yield oSigner.propset_CheckCertificate(true);

              var oSignedData = yield cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");
              oSignedData.propset_ContentEncoding(cadesplugin.CADESCOM_BASE64_TO_BINARY);

              try {
                var sSignedMessage = yield oSignedData.SignHash(oHashedData, oSigner, cadesplugin.CADESCOM_CADES_BES);
              } catch (err) {
                alert("Failed to create signature. Error: " + cadesplugin.getLastError(err));
                return;
              }
              yield oStore.Close();

              _this.ecpValue = sSignedMessage;
              _this.showECP = false;
              let sn = sCertName.split(",");
              sn.forEach(function(v) {
                let r = v.replace("CN=", "");
                if (r.length !== v.length) {
                  _this.ecpEnsurer = r.trim();
                }
              });

              // Проверим подпись
              var oSignedData2 = yield cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");
              try {
                yield oSignedData2.VerifyHash(oHashedData, sSignedMessage, cadesplugin.CADESCOM_CADES_BES);
                //alert("Signature verified");
                _this.isEDSWorkAndGood = true;
                console.log("Signature verified");
              } catch (err) {
                alert("Failed to verify signature. Error: " + cadesplugin.getLastError(err));
                return;
              }
            });
          }
        };

        var frOnerror = function() {
          alert("File load error.");
        };

        function loadNext() {
          var fileReader = new FileReader();
          fileReader.onload = frOnload;
          fileReader.onerror = frOnerror;

          var start = currentChunk * chunkSize,
            end = ((start + chunkSize) >= oFile.size) ? oFile.size : start + chunkSize;

          fileReader.readAsDataURL(blobSlice.call(oFile, start, end));
        };

        loadNext();
      });
    },
    bindChange() {
      if (this.typeIndex < 0) {
        return;
      }
      let types = this.docs[this.typeIndex].EXT.split(";");
      this.file = "";
      this.fileName = "Файл не выбран";
      this.ecpCert = null;
      this.ecpValue = "";
      this.errorText = "";

      this.accept = "";
      if (
        this.docs[this.typeIndex].IS_MULTIPLY &&
        this.docs[this.typeIndex].IS_FILE_MANAGER_REQUEST
      ) {
        this.accept = "." + this.docExts.join(",.");
      } else {
        this.accept = "." + types.join(",.");
      }
    },
    submit() {
      this.uploadBlockButton = true; //блокировка кнопки
      if (typeof this.$refs.file.files[0] === "undefined") {
        return false;
      }

      let formData = new FormData();
      /*if (this.docName > 0) {
        formData.append("ID", this.docName);
      }*/
      formData.append("ID", this.docsType[this.typeIndex].FILE_INFO.ID);
      if (this.addDocForm.FILE) {
        formData.append("FILE", this.addDocForm.FILE);
        formData.append("FILE_NAME", this.addDocForm.FILE_NAME);
      }
      //formData.append("FILE", this.$refs.file.files[0]);

      formData.append(
        "UF_TYPE_DOC_DZ_ID",
        this.docsType[this.typeIndex].TYPE_ID
      );
      formData.append(
        "RECORD_MODEL_ID",
        this.docsType[this.typeIndex].RECORD_MODEL_ID
      );

      if (this.docsType[this.typeIndex].IS_ECP_REQ) {
        formData.append("UF_FILE_SIGN_ECP", this.ecpValue);
        formData.append("UF_FILE_SIGN_AUTHOR", this.ecpEnsurer);
        //formData.append("UF_HASH", this.hashFile);
        formData.append("UF_IS_DETACHED_SIGNATURE", 1);
      }

      ProjectsService.saveDocumentDZ(
        this.project.ID,
        formData,
        this.fileForm
      ).then(response => {
        console.log(response);
        if (!response.data.error) {
          this.updateDocInfo();
          this.showUploader = false;
          this.$toasted.show("Документ успешно загружен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.errorArr = response.data.errorArr;
          this.uploadBlockButton = false;
        }
      }, this);
      return false;
    },
    changeFileLast() {
      let reader = new FileReader();
      this.ecpValue = "";
      this.ecpCert = "";
      (this.errorText = ""), reader.readAsDataURL(this.$refs.file.files[0]);
      reader.onload = () => {
        let file = this.$refs.file.files[0];
        if (file.size < 1024 * 1024 * 100) {
          let header = ";base64,";
          let fileData = reader.result;

          this.fileBase64 = fileData.substr(
            fileData.indexOf(header) + header.length
          );
        } else {
          this.errorText =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 100 Мб";
        }
      };
      this.fileName = this.$refs.file.files[0].name;
      this.fileName2 = this.fileName;
      this.fileName = "    ";
    },
    changeFile(e) {
      this.ecpValue = "";
      this.ecpCert = "";
      this.isBigFile = false;
      this.isEDSWorkAndGood = false;

      let files = e.target.files;
      if (files.length > 0) {
        let file = files[0];
        if (file.size < 1024 * 1024 * 100) {
          this.fileName = file.name;
          this.addDocForm.FILE = file;
          this.addDocForm.FILE_NAME = this.fileName;

          if (file.size < 1024 * 1024 * 40) {//меньше 40Мб
            //для подписи ЭЦП
            let reader = new FileReader();

            if (typeof (reader.readAsDataURL) != "function") {
              alert("Method readAsDataURL() is not supported in FileReader.");
              return;
            }

            reader.readAsDataURL(this.$refs.file.files[0]);

            reader.onload = () => {
              let file = this.$refs.file.files[0];
              if (file.size < 1024 * 1024 * 100) {
                let header = ";base64,";
                let fileData = reader.result;

                this.fileBase64 = fileData.substr(
                  fileData.indexOf(header) + header.length
                );
              }
            };

          } else {
            this.isBigFile = true;
          }

        } else {
          this.errorText =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 100 Мб";
        }
      }
    }
  }
};
</script>

<style scoped></style>
